import React, { Component } from 'react'
import { Container } from '@sencha/ext-modern'
import Message from '../../components/Message'
import SearchBar from './SearchBar'
import ListItem from './ListItem'
import ExpenseTypeSelect from './ExpenseTypeSelect'

Ext.require([
    'Ext.dataview.listswiper.ListSwiper',
    'Ext.MessageBox'
])
const style = {
    outer: {
        backgroundColor: "#f5f5f5",
        paddingTop: "10px",
        paddingBottom: "10px"
    }
}
class ExpenseApplication extends Component {
    state = {
        query: '',
        loading: false,
        errorMessage: null,
        selectedStatus: 0,
        ExpenseList: null,
        pageCount: 10,
        page: 1,
        totalCount: 0
    }

    componentDidMount() {
        const { pageCount } = this.state
        this.GetExpenseList(pageCount)
    }

    GetExpenseList = (row) => {
        const { query, selectedStatus } = this.state
        const { match: { params: { type } } } = this.props
        Tyan.doPostEvent('GetExpenseList', {
            data: { type, status: selectedStatus, row, query, },
            onRequest: () => {
                this.setState({ loading: true })
            },
            onEnd: ({ errorMessage, expenseList, totalCount, statusList }) => {
                if (errorMessage) {
                    this.setState({ errorMessage })
                    return
                }
                this.setState({ loading: false, expenseList, totalCount, statusList })
            }
        })
    }

    handleLoadMore = () => {
        let { page, pageCount } = this.state
        page += 1
        this.GetExpenseList(pageCount * page)
        this.setState({ page })
    }

    handleChange = (field, value) => {
        this.setState({ query: value })
    }

    handleSearch = () => {
        const { pageCount } = this.state
        this.GetExpenseList(pageCount)
    }

    handleAdd = ({ showDetail }) => {
        // const { match: { params: { type } } } = this.props
        Tyan.pubForm.showDialog('报支单选择', props => <ExpenseTypeSelect showDetail={showDetail} {...props} />)
    }

    handleSelectStatus = (e) => {
        this.setState({ selectedStatus: e.value })
        const { pageCount } = this.state
        this.GetExpenseList(pageCount)
    }

    handleChildTap = ({ id, expenseName }) => {
        if(expenseName == '出差/外训报支单'){
            expenseName = '出差外训报支单'
        }
        location.hash = `/QYWX/ExpenseApply/${id}/${expenseName}`
    }

    render() {
        const { expenseList, errorMessage, query, selectedStatus, totalCount, statusList } = this.state
        if (errorMessage) {
            return <Message text="数据加载失败" subText={errorMessage} />
        } else if (!expenseList) {
            return <Message text="数据加载中..." />
        }

        return (
            <Container layout={{ type: "vbox" }} style={style.outer} scrollable >
                <SearchBar selectedStatus={selectedStatus} statusList={statusList.map(o => [o, o])} handleChange={this.handleChange} handleSearch={this.handleSearch} query={query} handleSelectStatus={this.handleSelectStatus} handleAdd={this.handleAdd} />
                <ListItem listData={expenseList} totalCount={totalCount} handleLoadMore={this.handleLoadMore} handleChildTap={this.handleChildTap} />
            </Container>
        )
    }
}
export default ExpenseApplication